<template>
  <div class="grid-container">
    <div class="grid-row">
      <ResumeMusicVimeoEmbed :id="174053285"/>
      <ResumeMusicVimeoEmbed :id="197982990"/>
    </div>
  </div>
</template>
